var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.faiked)?_c('ul',{staticClass:"float"},_vm._l((_vm.Data),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":{name:item.url}}},[_c('img',{attrs:{"src":'img/'+item.src}}),_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }